import {
  BRAND_REFRESH_SHOW_WELCOME_SESSION_KEY,
  BRAND_REFRESH_WELCOME_QUEUED_EVENT,
} from './constants'

export function queueBrandRefreshWelcomeModal(): void {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  sessionStorage.setItem(BRAND_REFRESH_SHOW_WELCOME_SESSION_KEY, 'true')
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BRAND_REFRESH_WELCOME_QUEUED_EVENT))
  }
}

export function clearBrandRefreshWelcomeModalQueue(): void {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  sessionStorage.removeItem(BRAND_REFRESH_SHOW_WELCOME_SESSION_KEY)
}

export function shouldShowBrandRefreshWelcomeModal(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false
  }
  return sessionStorage.getItem(BRAND_REFRESH_SHOW_WELCOME_SESSION_KEY) === 'true'
}
